// src/components/BlogForm.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BlogForm = ({ blog, onBlogAdded, onBlogUpdated, onAlert }) => {
  const [heading, setHeading] = useState('');
  const [paragraphs, setParagraphs] = useState('');
  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState('');

  useEffect(() => {
    if (blog) {
      setHeading(blog.heading);
      setParagraphs(blog.paragraphs.join('\n'));
      setImageUrl(blog.image);
    }
  }, [blog]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('heading', heading);
    formData.append('paragraphs', paragraphs);
    if (image) {
      formData.append('image', image);
    }

    try {
      if (blog) {
        await axios.put(`https://sribala.hxbindia.com/blogs/${blog._id}`, formData);
        onBlogUpdated();
        onAlert('Blog updated successfully!', 'success');
      } else {
        const response = await axios.post('https://sribala.hxbindia.com/blogs', formData);
        onBlogAdded(response.data);
        onAlert('Blog created successfully!', 'success');
      }
    } catch (error) {
      console.error('Error:', error);
      onAlert('Error performing action.', 'danger');
    }
  };

  return (


    <>

<div className="container d-flex justify-content-center ">
      <div className="col-md-7 pt-5">
      <h1 className='text-success mb-5'>Manage Blogs</h1>
      <ul>
  <h4>Steps To Follow</h4>
  <hr />
<li>
  Use "|" to separate or break line.
</li>
<li>
  Maximum 1 images.
</li>

</ul>
    <form onSubmit={handleSubmit} className="mb-3">
      <div className="mb-3">
        <label className="form-label">Heading</label>
        <input
          type="text"
          className="form-control"
          value={heading}
          onChange={(e) => setHeading(e.target.value)}
          required
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Paragraphs</label>
        <textarea
          className="form-control"
          value={paragraphs}
          onChange={(e) => setParagraphs(e.target.value)}
          required
              placeholder='use "|" to break line'
        ></textarea>
      </div>
      <div className="mb-3">
        <label className="form-label">Image</label>
        <input type="file" className="form-control" onChange={(e) => setImage(e.target.files[0])} />
      </div>
      {imageUrl && (
        <div className="mb-3">
          <img src={`https://sribala.hxbindia.com/${imageUrl}`} alt="Blog" className="img-fluid" style={{ maxWidth: '200px' }} />
        </div>
      )}
      <button type="submit" className="btn btn-success">{blog ? 'Update' : 'Add'} Blog</button>
    </form>
</div>
</div>
    </>
  );
};

export default BlogForm;
